<template>
    <div class="coupon-item" 
      :class="{disabled: !formatCoupon.isBeforeTimeRange && (formatCoupon.isAfterTimeRange || formatCoupon.computed_status === 2) }"
    >
      <!-- 顶部可用范围显示区域，只有不是单独一个样式才显示 -->
      <template v-if="floorInfo.pc_per_row_number !== 1">

        <div v-if="formatCoupon.scope === 1 && formatCoupon.countries.length" class="coupon-limit-box" @click.stop="handleShowDescPopup">
          <div class="limit-text">
            <span v-if="formatCoupon.countries.length === 1">{{formatCoupon.countries[0].country}}优惠券</span>
            <span v-else-if="formatCoupon.countries.length > 1">限指定国家使用</span>
          </div>
          <img class="limit-img" v-if="formatCoupon.countries.length > 1" src="https://o.666visa.cn/static/ssqwxa/activity/daily-activity/daily-activity-7.png" />        
        </div>

        <div v-if="formatCoupon.scope === 2 && formatCoupon.products.length" class="coupon-limit-box" @click.stop="handleShowDescPopup">
          <div class="limit-text">限指定商品使用</div>
          <img class="limit-img" v-if="formatCoupon.products.length" src="https://o.666visa.cn/static/ssqwxa/activity/daily-activity/daily-activity-7.png" />        
        </div>
      </template>

      <div class="coupon-top">
        <!-- 当一行展示一个的时候有国家优惠券需要展示占个位 显示还是用原来的显示 -->
        <div class="coupon-left">
          <div class="price-box" v-if="formatCoupon.coupon_type_id === 0">
            <span class="unit">￥</span><span class="num">{{ formatCoupon.cash_reduce / 100 }}</span>
          </div>
          <div class="coupon-discount" v-if="formatCoupon.coupon_type_id === 1">
            <span class="num">{{ formatCoupon.cash_reduce / 1000 }}</span>
            <span class="unit">折</span>
          </div>
          <div class="free-order" v-if="formatCoupon.coupon_type_id === 2">免<span class="num">{{ formatCoupon.reduce_num }}</span>单</div>
        </div>
 
        <div class="coupon-dec" >
          <!-- 全部商品 -->
          <template v-if="formatCoupon.scope === 0">
            <div class="goods-category" v-if="!formatCoupon.reach_reduce">
              <span v-if="formatCoupon.exclusion_scope === 0">全品类</span>           
              <span class="max-price">无门槛</span>
            </div>
            <div class="goods-category" v-else>{{`满${ formatCoupon.reach_reduce / 100 }元可用` }}</div>  
          </template>
          <!-- 指定国家 -->
          <template v-if="formatCoupon.scope === 1">
            <template v-if="formatCoupon.countries.length">
              <div class="goods-category">{{formatCoupon.reach_reduce ? `满${ formatCoupon.reach_reduce / 100 }元可用` :'无门槛'}}</div>
              <template v-if="floorInfo.pc_per_row_number === 1">
                <div v-if="formatCoupon.countries.length === 1" class="coupon-country" >{{formatCoupon.countries[0].country}}优惠券</div>  
                <div v-else="formatCoupon.countries.length" @click="handleShowDescPopup" class="limit-product">
                  <span class="limit-product-text">限指定国家使用</span>
                  <img class="limit-product-img" src="https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-9.png" alt="">
                </div>
              </template>
              
            </template>
            <div v-else class="limit-product" :class="{'single-show':!formatCoupon.products.length}">
              <div class="limit-product-text">指定国家已下架</div>
            </div>
          </template>
          <!-- 指定商品 -->
          <template v-if="formatCoupon.scope === 2">
            <template v-if="formatCoupon.products.length">
              <div class="goods-category">{{formatCoupon.reach_reduce ? `满${ formatCoupon.reach_reduce / 100 }元可用` :'无门槛'}}</div>         
              <div v-if="floorInfo.pc_per_row_number === 1" class="limit-product" @click="handleShowDescPopup">
                <span class="limit-product-text">限指定商品使用</span>
                <img class="limit-product-img" src="https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-9.png" alt="">
              </div>
            </template>
            <div v-else class="limit-product" :class="{'single-show':!formatCoupon.products.length}">
              <div class="limit-product-text">指定商品已下架</div>
            </div>
          </template>
        </div>
      </div>
      <div class="coupon-bottom">
        <template v-if="formatCoupon.isBeforeTimeRange">
          <div class="before-receive" v-if="floorInfo.pc_per_row_number === 1">{{formatCoupon.open_time}}<br/>开抢</div>
          <div class="before-receive" v-else>{{formatCoupon.open_time}}开抢</div>
        </template>

        <template v-else-if="formatCoupon.isAfterTimeRange || formatCoupon.computed_status === 2">
          <div class="disabled-receive" v-html="endingText"></div>
        </template>

        <div v-else-if="formatCoupon.computed_status === 0" class="allow-receive" @click="receiveCoupon()">
          <img v-if="floorInfo.pc_per_row_number === 1" class="allow-img" src="https://o.666visa.cn/static/ssqpeer/activity/daily-activity/daily-activity-3.png" alt="">
          <template v-else>
            <div class="receive-btn">立即领取</div>
            <img class="icon-right" src="https://o.666visa.cn/static/ssqwxa/activity/daily-activity/icon-right.png" />
          </template>
        </div>

        <template v-else-if="formatCoupon.computed_status === 1">
          <div class="received" @click="gotoDestination">去使用</div>
        </template>
      </div>

      <coupon-desc-dialog :show.sync="showCouponDescDialog" :coupon="formatCoupon"></coupon-desc-dialog>

    </div>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import { Loading } from 'element-ui';
import moment from 'moment';
import { mapMutations } from 'vuex';
import CouponDescDialog from '@/pages/user/user-children/components/coupon-desc-dialog';
import User from '../../../../libs/user';
import dailyActivityApi from '../../../../api/daily-activity-api';
import utils from '../../../../libs/utils';


export default {
  name: '',
  components: { CouponDescDialog },
  props: {
    coupon: {
      type: Object,
      default: null,
    },
    activityFloorInfo: {
      type: Object,
      default: {},
    },
    floorInfo: {
      type: Object,
      default: {},
    },
  },
  computed: {
    // 已结束的文案
    endingText() {
      const { per_day_count, remaining_num } = this.coupon;
      const { pc_per_row_number } = this.floorInfo;
      if (per_day_count === 0 && remaining_num > 0) {
        return `${pc_per_row_number !== 1 ? '&nbsp;&nbsp;' : ''}抢光了！<br/>明天再来吧${pc_per_row_number === 1 ? '&nbsp;&nbsp;' : ''}`;
      }

      return '&nbsp;&nbsp;抢光了！';
    },
    nowDate() {
      return moment(this.nowTime).utcOffset(8).format('yyyy-MM-DD');
    },
    nowHourMinute() {
      console.log('时分秒', moment(this.nowTime).utcOffset(8).format('HH:mm'));
      return moment(this.nowTime).utcOffset(8).format('HH:mm:ss');
    },
    isBeforeTimeRange() {
      const { receive_type, start_time, end_time } = this.floorInfo.couponInfo;
      const [startDate, startTime] = start_time.split(' ');
      const [endDate, endTime] = end_time.split(' ');
      if (receive_type === 1) { // 普通优惠券
        const startTimeString = Date.parse(this.floorInfo.couponInfo.start_time);
        return this.nowTime < startTimeString;
      }
      // 多日秒杀
      return this.nowDate < startDate || (this.nowDate <= endDate && this.nowHourMinute < startTime);
      
    },
    isAfterTimeRange() {
      const { receive_type, start_time, end_time } = this.floorInfo.couponInfo;
      const [startDate, startTime] = start_time.split(' ');
      const [endDate, endTime] = end_time.split(' ');
      if (receive_type === 1) { // 普通优惠券
        const endTimeString = Date.parse(this.floorInfo.couponInfo.end_time);
        return this.nowTime > endTimeString; 
      }
      return this.nowDate > endDate || (this.nowDate >= startDate && this.nowHourMinute > endTime);
    },
    open_time() {
      const open_time = new Date(this.floorInfo.couponInfo.start_time).format('hh:mm');
      return open_time;
    },
    computed_status() {
      const { max_exchange, exchange_count, status, per_day_count } = this.coupon; // max_exchange 总优惠 exchange_count已领取 
      // 0 可领取  1：已领取 2: 领取完
      let computed_status = 0;

      // 没有兑换的数量，总数空，或者当天空
      const noExchangeNum = (max_exchange - exchange_count === 0) || per_day_count === 0;
      if ((noExchangeNum && status !== 1) || status === 2) {
        computed_status = 2;
      } else if (status === 1) {
        computed_status = 1;
      }
      return computed_status;
    },
    formatCoupon() {
      if (!this.coupon) return {};
      const isBeforeTimeRange = this.isBeforeTimeRange;
      const isAfterTimeRange = this.isAfterTimeRange;
      const open_time = this.open_time;
      const computed_status = this.computed_status;
      return { ...this.coupon, isBeforeTimeRange, isAfterTimeRange, open_time, computed_status };
    },
    
  },
  data() {
    return {
      User,
      showCouponDescDialog: false,
      nowTime: 0, // 当前时间戳
      timer: null,
      receiveLoading: false,
    };
  },
  mounted() {
    this.initNowTime();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    ...mapMutations(['SHOW_LOGIN_BOX']),
    initNowTime() {
      this.nowTime = new Date().getTime();
      this.timer = setInterval(() => {
        this.nowTime = new Date().getTime();
      }, 1000);
    },
    handleShowDescPopup() {
      if (
        (this.formatCoupon.scope === 1 && this.formatCoupon.countries.length > 1) ||
        (this.formatCoupon.scope === 2 && this.formatCoupon.products.length)
      ) {
        this.showCouponDescDialog = true;
      }
    },
    // 领取优惠券
    async receiveCoupon() {
      if (User.isLogin() && this.activityFloorInfo.channel) {
        sensorsdata.track('ActivityPageCoupon', {
          activity_id: this.activityFloorInfo.id,
          activity_name: this.activityFloorInfo.title,
          scene_name: this.activityFloorInfo.channel.channel_name,
          scene_code: this.activityFloorInfo.channel.channel_no,
          platform_type: 'PC',
          peer_name: User.peer_name,
          visa_peer_id: User.visa_peer_id,
          coupon_id: this.formatCoupon.coupon_id,
        });
      }

      // 未登录跳转到登录
      if (!User.isLogin()) {
        this.SHOW_LOGIN_BOX({ from: 'activity' });
        return;
      }
      if (this.receiveLoading) return;
      this.receiveLoading = true;
      const loadingInstance = Loading.service({
        text: '领取中',
      });
      try {
        await dailyActivityApi.receiveCoupon({ id: this.formatCoupon.id });
        utils.msg.success('领取成功');

        this.updateCurrentCouponInfo();
        loadingInstance.close();
        this.receiveLoading = false;
      } catch (err) {
        loadingInstance.close();
        this.receiveLoading = false;
      }
    },
    // 更新当前优惠券状态
    async updateCurrentCouponInfo() {
      // 需要更新的楼层索引
      const floorIndex = this.activityFloorInfo.activity_floor.findIndex(item => item.id === this.floorInfo.id);
      const info = await dailyActivityApi.getFloorCouponInfo({ id: this.activityFloorInfo.id, floor_id: this.floorInfo.id });
      this.$emit('updateCurrentCouponInfo', { floorIndex, info });
    },
    gotoDestination() {
      this.$router.push({ name: 'countries' });
    },
  },
};
</script>

 
<style scoped lang="less">
 .coupon-item{
  background-position: center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: #fff;
  position: relative;
  &.disabled{
    .coupon-left,.max-price{
      color: rgba(255, 33, 57, 0.6);
    }
    .goods-category{
      color: rgba(145, 89, 71, 0.6);
    }
    .coupon-bottom{
      .before-receive, .disabled-receive{
        color: rgba(90, 54, 43, 0.6);
      }
      .allow-receive, .received{
        color: rgba(255,255,255,0.5);
      }
    }
    .coupon-country{
      color: rgba(145, 89, 71, 0.6);
      background: rgba(255, 223, 185, 0.6);
    }
    .limit-product{
      color: rgba(145, 89, 71, 0.6);
    }
  }
  .coupon-limit-box{
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    max-width: 90%;
    color: #915947;
    text-align: center;
    display: flex;
    align-items: center;
    background: #FFDFB9;
    border-radius: 0 0 16px 16px;
    height: 36px;
    padding: 0 10px;
    cursor: pointer;
    .limit-text{
      flex-grow: 1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 20px;
    }
    .limit-img{
      flex-shrink: 0;
      margin-left: 4rpx;
      width: 24px;
      height: 24px;
    }
  }
  .coupon-country{
    text-align: center;
    color: #915947;
    font-size: 20px;
    height: 36px;
    line-height: 36px;
    background: transparent;
    border-radius: 0px 0px 16px 16px;
    padding: 0 10px;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
  }

  .coupon-left{
    color: #FF2139;
    font-weight: 600;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .price-box{
      display: flex;
      align-items: center;
      justify-content: center;
      .unit{
        font-size: 32px;
        margin-top: 22px;
      }
      .num{
        font-size: 60px;
        margin-left: -4px;
      }
    }
    .coupon-discount{
      display: flex;
      align-items: center;
      justify-content: center;
      .num{
        font-size: 60px;
        line-height: 60px;
      }
      .unit{
        margin-left: 4px;
        font-size: 28px;
        margin-top: 10px;
      }
    }
    .free-order{
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 44px;
      .num{
        font-size: 60px;
      }
    }
  }

  .coupon-dec{
    display: flex;
    justify-content: center;
    white-space: nowrap;
    flex-direction: column;
  }
  .goods-category{
    color: #915947;
    font-size: 22px;
    text-align: center;
    margin-top: 12px;
  }
  .max-price{
    font-size: 22px;
    color: #FF2139;
  }
  .coupon-top{
    flex: 1;
  }
  .coupon-bottom{
    width: 100%;
    height: 70px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .before-receive, .disabled-receive{
    font-size: 24px;
    line-height: 28px;
    color: rgba(90, 54, 43, 0.6);
    text-align: center;
  }
  .received{
    color: #FF2139;
    font-size: 24px;
    font-weight: 600;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .allow-receive{
    cursor: pointer;
    color: #5A362B;
    font-size: 24px;
    font-weight: 500;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .icon-right{
      width: 20px;
      height: 20px;
      margin-left: 2px;
    }
  }

  .allow-receive{
    cursor: pointer;
  }

  .one-receive-box{
    display: flex;
    flex-direction: column;
  }
  .one-receive-text{
    color: rgba(225, 225, 225, 0.6);
    font-size: 24px;
  }
  .limit-product{
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 22px;
    margin-top: 12px;
    color: #915947;
    justify-content: center;
  }
  .limit-product-img{
    width: 20px;
    height: 20px;
    margin-left: 7px;
  }
}
.limit-product-text{
  font-size: 28px;
}

</style>


// WEBPACK FOOTER //
// src/pages/activity/daily-activity/components/coupon-item.vue